// Cart functionality for Shopify

class CartDrawer {
  constructor() {
    this.init();
  }

  init() {
    // Cart update functionality
    document.addEventListener('submit', (e) => {
      if (e.target.matches('[data-cart-form]')) {
        this.updateCart(e);
      }
    });
  }

  updateCart(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated:', data);
      window.location.reload();
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartDrawer();
  });
} else {
  new CartDrawer();
}
